// extracted by mini-css-extract-plugin
export var actions = "_n0-5";
export var assistantBubble = "_n0-3";
export var assistantRow = "_n0-6";
export var bubble = "_n0-0";
export var humanAvatar = "_n0-4";
export var inlineToolCard = "_n0-1";
export var userBubble = "_n0-2";